"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.SbButtonGroup = void 0;

var _react = _interopRequireDefault(require("react"));

var _classnames = _interopRequireDefault(require("classnames"));

var _propTypes = _interopRequireDefault(require("prop-types"));

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

/**
 * @class
 * @classdesc
 * @desc
 * Simple wrapper for group of buttons, providing indent between elements.
 *
 * @param   {object}          props - Default properties.
 * @returns {React.Component} *     - Generated react component.
 */
var SbButtonGroup = function SbButtonGroup(props) {
  var children = props.children,
      id = props.id,
      style = props.style,
      className = props.className,
      orientation = props.orientation;
  var classNames = (0, _classnames.default)('sb-button-group', className, {
    horizontal: !orientation || orientation === SbButtonGroup.ORIENTATION_TYPE.horizontal,
    vertical: orientation === SbButtonGroup.ORIENTATION_TYPE.vertical
  });
  /**
   * Render
   */

  return /*#__PURE__*/_react.default.createElement("div", {
    id: id,
    className: classNames,
    style: style
  }, children);
};
/**
 * @enum
 * @desc
 * Enum for orientation type.
 *
 * @type {{horizontal: number, vertical: number}}
 */


exports.SbButtonGroup = SbButtonGroup;
SbButtonGroup.ORIENTATION_TYPE = {
  horizontal: 0,
  vertical: 1
};
SbButtonGroup.propTypes = {
  children: _propTypes.default.oneOfType([_propTypes.default.array, _propTypes.default.element]).isRequired,
  id: _propTypes.default.string,
  style: _propTypes.default.object,
  // eslint-disable-line
  className: _propTypes.default.string,
  orientation: _propTypes.default.oneOf([SbButtonGroup.ORIENTATION_TYPE.horizontal, SbButtonGroup.ORIENTATION_TYPE.vertical])
};
SbButtonGroup.defaultProps = {
  id: null,
  style: null,
  className: null,
  orientation: SbButtonGroup.ORIENTATION_TYPE.horizontal
};
//# sourceMappingURL=sb-button-group.js.map